export default {
  chatbot: {
    toggle_label: "Abrir la asistente Léa",
    close_label: "Cerrar la asistente Léa",
    panel_label: "Asistente Léa",
    send_label: "Enviar el mensaje",
    stop_label: "Detener la generación",
    loading_label: "Léa está escribiendo…",
  },
};
